import { AutoComplete, AutoCompleteProps, Box } from '@wix/design-system'
import { PopoverCommonProps } from '@wix/design-system/dist/types/common'
import { Search } from '@wix/wix-ui-icons-common/lazy'
import React, { forwardRef, useMemo } from 'react'

import s from './FancyAutoComplete.scss'

type AutoCompleteRenderer = React.ComponentType<AutoCompleteProps & React.RefAttributes<AutoComplete>>

type Props = {
  prefixNode?: React.ReactNode
  customRenderer?: AutoCompleteRenderer
  isIconHidden?: boolean
} & Omit<AutoCompleteProps, 'menuArrow'>

export const FancyAutoComplete = forwardRef<AutoComplete, Props>((props, ref) => {
  const inputClassName = [props.className, s.root].filter(Boolean).join(' ')
  const popoverProps: PopoverCommonProps = {
    timeout: 1,
    moveBy: { y: 12 },
    ...(props.popoverProps ?? {}),
  }

  const prefixNode = useMemo(
    () => (
      <Box height="100%" verticalAlign="middle">
        <Search color="#116DFF" />
      </Box>
    ),
    [],
  )

  const Cmp = props.customRenderer ?? AutoComplete

  const prefix = useMemo(() => {
    if (props.isIconHidden) {
      return undefined
    }

    return props.prefixNode ?? prefixNode
  }, [prefixNode, props.isIconHidden, props.prefixNode])

  return (
    <Cmp
      {...props}
      ref={ref}
      prefix={prefix}
      menuArrow={false}
      className={inputClassName}
      popoverProps={popoverProps}
    />
  )
})
